import { toString } from '../shortcut'

import type { TFunction, TRecord } from '../types'

export function getProxyRaw<T extends TRecord>(target?: T): T {
  return target?.__r_proxy_raw ?? target
}

export function isAsyncFn(value?: any): value is TFunction {
  const string = toString.call(value)
  return (
    string === '[object AsyncFunction]' ||
    string === '[object AsyncGeneratorFunction]'
  )
}

export function isDateLike(value?: any): boolean {
  return (
    typeof value === 'string' || typeof value === 'number' || isDateObj(value)
  )
}

export function isDateObj(value?: any): value is TRecord {
  return (
    value instanceof Date ||
    value?._isAMomentObject !== undefined ||
    value?.$isDayjsObject !== undefined
  )
}

export function isGeneratorFn(value?: any): value is TFunction {
  const string = toString.call(value)
  return (
    string === '[object GeneratorFunction]' ||
    string === '[object AsyncGeneratorFunction]'
  )
}

export function isPlainObj(value?: any): value is TRecord {
  return toString.call(value) === '[object Object]'
}

export function isProxyRawKey(key: PropertyKey) {
  return key === '__r_proxy_raw'
}
